<div class="row mt-4">
    <div class="col-md-10  page-header">
        <h2 class="mb-0 common-bene-class-for-translation">Compliance Info </h2>
        <p class="common-bene-class-for-translation">Manage all the compliance data and keep your data compliant</p>
    </div>
    <div class="col-2">
        <app-help-video-overlay #helpVideoComponent></app-help-video-overlay>
    </div>
</div>
<div>
    <div class="col-md-2 pull-left card  card-min no-border border-left side-nav">
        <button mat-button class="text-left side-nav-btn" routerLinkActive="activated" routerLink="../compliance/public-access"
            *ngIf="userType != 'Beneficiary'"><span class="common-bene-class-for-translation">Public Access File</span></button>
        <button mat-button class="text-left side-nav-btn" routerLinkActive="activated" routerLink="../compliance/private-access"
            *ngIf="userType != 'Beneficiary'"><span class="common-bene-class-for-translation">Private Access File</span></button>
        <button mat-button class="text-left side-nav-btn" routerLinkActive="activated" routerLink="../compliance/i9-forms"
            *ngIf="userType != 'Beneficiary'"><span class="common-bene-class-for-translation">I-9 Forms</span></button>
        <button mat-button class="text-left side-nav-btn" routerLinkActive="activated" routerLink="../compliance/fdns-qa" *ngIf="userType != 'Attorney'"><span class="common-bene-class-for-translation"> FDNS </span>
            <span class="common-bene-class-for-translation"> Q </span> & <span class="common-bene-class-for-translation"> A </span></button>
        <button mat-button class="text-left side-nav-btn" routerLinkActive="activated" routerLink="../compliance/fdns-visit"
        *ngIf="userType != 'Beneficiary'"><span class="common-bene-class-for-translation">FDNS Visit</span></button>
    </div>
    <div class="col-md-10  pull-right bordered-panel complianceWhiteBg">
        <router-outlet></router-outlet>
    </div>
    <div class="clearfix"></div>
</div>
<div class="clearfix"></div>